export const badRequestInterceptor = (error) => {
  return Promise.reject(error);
};
